import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'MetaMask',
    disabledWallet:
      'The MetaMask cannot be used concurrently with the {wallet} wallet.',
    disabledByOtherWallets:
      'The MetaMask cannot be used simultaneously with some of your currently active wallets.',
  },
};
